
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { LMap, LTileLayer, LMarker, LControl, LPolyline, LIcon } from 'vue2-leaflet';
import { HistoryData } from '@/types/history';
import { LatLngBoundsExpression } from 'leaflet';

@Component({
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LControl,
        LPolyline,
        LIcon,
    },
})
export default class MapControl extends Vue {
    protected url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
    protected mapCenter: number[] = [-33.865143, 151.2099];

    @Prop({ required: true, default: [] })
    locations!: HistoryData[];

    @Prop({ required: false, default: 2 })
    zoom!: number;

    @Prop({ required: false, default: 'height: 350px; z-index: 0' })
    styles!: string;

    @Watch('locations', { immediate: true, deep: true })
    onLocationsChange(locations: HistoryData[]) {
        if (this.$refs.lmap) {
            const bounds: LatLngBoundsExpression = locations.map((l: HistoryData) => [l.latitude, l.longitude]);
            if (bounds.length > 0) (this.$refs.lmap as LMap).fitBounds(bounds);
        }
    }
}
